import { createContext, useState } from 'react';
import { Message } from '../types';
import { Snackbar, Alert, AlertColor } from '@mui/material';

export const MessageContext = createContext({
    openMessage: false,
    setOpenMessage: (open: boolean) => {},
    message: {} as Message,
    setMessage: (message: Message) => {}
});

export const MessageProvider = ({ children }) => {
    const [openMessage, setOpenMessage] = useState<boolean>(false);
    const [message, setMessage] = useState<Message>({} as Message);

    return (
        <MessageContext.Provider
            value={{
                openMessage: openMessage,
                setOpenMessage: setOpenMessage,
                message: message,
                setMessage: setMessage
            }}
        >
            {children}

            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                open={openMessage}
                onClose={() => setOpenMessage(false)}
                autoHideDuration={6000}
            >
                <Alert severity={message.type as AlertColor} sx={{ width: '100%' }}>
                    {message.content}
                </Alert>
            </Snackbar>
        </MessageContext.Provider>
    );
};
